import ReactDOMServer from "react-dom/server";
import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

const LegendContainer = styled.div`
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    font-family: Roboto;
`;

const LabelName = styled.span`
    font-size: 14px;
    font-weight: 300;
    color: ${colorsPalettes.carbon[500]};
    margin-bottom: 4px;
`;

const LabelValue = styled.span`
    font-size: 24px;
    font-weight: 400;
    color: ${colorsPalettes.carbon[500]};
`;

const PieChartLegend = (props: { pointName: string; pointValue: number }) => {
    const { pointName, pointValue } = props;

    return (
        <LegendContainer>
            <LabelName>{pointName}</LabelName>
            <LabelValue>{pointValue}</LabelValue>
        </LegendContainer>
    );
};

export default ({ yAxisFormatter }) => {
    return {
        plotOptions: {
            pie: {
                showInLegend: true,
                point: {
                    events: {
                        legendItemClick() {
                            return false;
                        },
                    },
                },
            },
        },
        legend: {
            enabled: true,
            layout: "proximate",
            align: "right",
            verticalAlign: "top",
            useHTML: true,
            itemMarginBottom: 16,
            y: 10,
            x: 30,
            navigation: {
                enabled: false,
            },
            labelFormatter() {
                const formattedY = yAxisFormatter({ value: this.y });
                const name = this.name;

                return ReactDOMServer.renderToString(
                    <PieChartLegend
                        pointName={name}
                        pointValue={formattedY}
                    />,
                );
            },
        },
    };
};
